export default "__VITE_ASSET__$kkJeu9y__"